import React, { Component } from "react";
import { Row, Col, Button, Modal, Container, Form } from "react-bootstrap";
import Switch from "react-switch";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class AddBrand extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: {
        brandName: "",
        brandDescp: "",
        isActive: true
      }
    };
  }
  handleChange = checked => {
    this.setState({ value: { ...this.state.value, isActive: checked } });
  };
  onChange = event => {
    let name = event.target.name;
    let value = event.target.value;

    if (name == "brandName") {
      this.setState({
        value: { ...this.state.value, brandName: value }
      });
    } else if (name == "brandDescp") {
      this.setState({
        value: { ...this.state.value, brandDescp: value }
      });
    }
  };

  submit = () => {
    let data = this.state.value;
    // console.log(data);

    if (data.brandName !== "" && data.brandDescp !== "") {
      this.props.AddBrand(this.state.value);
      this.setState({
        value: {
          brandName: "",
          brandDescp: "",
          isActive: true
        }
      });
      this.props.closeAddModel();
      this.props.resetPage();
    } else {
      toast.error("Please fill all required fields", {
        autoClose: 2000,
        position: toast.POSITION.TOP_CENTER
      });
    }
  };

  closeModel = () => {
    this.setState({
      value: {
        brandName: "",
        brandDescp: "",
        isActive: true
      }
    });
    this.props.closeAddModel();
  };
  render() {
    return (
      <div>
        <Modal
          show={this.props.showAddModel}
          onHide={this.closeModel}
          animation={false}
          size="md"
          backdrop="static"
        >
          <Modal.Header
            style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
            closeButton
          >
            <Modal.Title>Brand</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Row>
                <Col lg={12}>
                  <Form>
                    <div style={{ maxWidth: 280, margin: "auto" }}>
                      <div>
                        <Form.Group controlId="brandName">
                          <Form.Label> Name </Form.Label>
                          <Form.Control
                            type="text"
                            // placeholder="Name"
                            autoComplete="off"
                            name="brandName"
                            onChange={this.onChange}
                            // value={this.state.value.brandName}
                          />
                        </Form.Group>
                      </div>

                      <div>
                        <Form.Group controlId="brandDescp">
                          <Form.Label> Description</Form.Label>
                          <Form.Control
                            as="textarea"
                            // placeholder=" Description"
                            name="brandDescp"
                            autoComplete="off"
                            onChange={this.onChange}
                            // value={this.state.value.brandDescp}
                          />
                        </Form.Group>
                      </div>

                      <div>
                        <label style={{ display: "flex", marginTop: "8px" }}>
                          <div style={{ marginRight: "30px" }}>
                            <span>Active</span>
                          </div>
                          <div style={{ marginTop: "-5px" }}>
                            <Switch
                              onChange={this.handleChange}
                              onColor="#20a8d8"
                              checked={this.state.value.isActive}
                            />
                          </div>
                        </label>
                      </div>
                    </div>
                  </Form>
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}>
            <Button type="submit" onClick={this.submit}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default AddBrand;
